export const MAP_STYLE = process.env.REACT_APP_MAP_STYLE || "";
export const MAP_TOKEN = process.env.REACT_APP_MAP_TOKEN || "";
export const APP_ASSETS = process.env.REACT_APP_ASSET_URL || "";
export const BEETLE_MAP_ID = process.env.REACT_APP_BEETLE_MAP_ID || "";

const venueWith3DModel = ["venue_elements", "venue_xiqu_centre"];

const venueData = [
  {
    code: "mplus",
    name: "venue_m_plus",
    center: {
      lat: 22.30083235,
      lng: 114.1591653,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1586267, 22.3002013],
          [114.1585899, 22.3007032],
          [114.1585889, 22.3007167],
          [114.1585396, 22.3013906],
          [114.1596983, 22.3014634],
          [114.159791, 22.3002743],
          [114.1597565, 22.3002721],
          [114.1591742, 22.3002356],
          [114.1587321, 22.3002079],
          [114.1586267, 22.3002013],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/m_plus/m_plus_20260223_1300.glb',
      center: {
        lat: 22.301135088001047,
        lng: 114.1590364018362,
        altitude: 0,
      },
      name: {
        en: "M+",
        zh: "M+"
      }
    }
  },
  {
    code: "kowloon",
    name: "venue_kowloon_station",
    center: {
      lat: 22.3053,
      lng: 114.1616,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1629246, 22.3058861],
          [114.1621037, 22.3040764],
          [114.1617867, 22.3033852],
          [114.1600681, 22.3040279],
          [114.1601896, 22.304299],
          [114.1602546, 22.3044439],
          [114.1606779, 22.3042928],
          [114.1606443, 22.3042159],
          [114.1606753, 22.3042051],
          [114.1607777, 22.3041738],
          [114.1607895, 22.3041681],
          [114.1610913, 22.3048867],
          [114.1612739, 22.305305],
          [114.1615579, 22.3059712],
          [114.1615427, 22.3059766],
          [114.1615004, 22.3059903],
          [114.1615375, 22.3060796],
          [114.161175, 22.3062131],
          [114.160803, 22.3053954],
          [114.1606956, 22.3054368],
          [114.1607256, 22.3055041],
          [114.1609306, 22.305965],
          [114.1610641, 22.3062519],
          [114.1610848, 22.3062979],
          [114.161195, 22.3065394],
          [114.1612005, 22.3065514],
          [114.1624164, 22.3060822],
          [114.1629246, 22.3058861],
        ],
      ],
    },
    model: {
      name: {
        en: "Kowloon Station",
        zh: "九龍站"
      }
    }
  },
  {
    code: "elements",
    name: "venue_elements",
    center: {
      lat: 22.3049, // 22.30491185,
      lng: 114.1614, // 114.1616615,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1605633, 22.3051394],
          [114.1606749, 22.3050969],
          [114.1606989, 22.3051506],
          [114.1607211, 22.3052064],
          [114.1608064, 22.3051747],
          [114.1608359, 22.3052426],
          [114.1608558, 22.3052886],
          [114.1607689, 22.3053209],
          [114.1607837, 22.3053522],
          [114.160803, 22.3053954],
          [114.1606956, 22.3054368],
          [114.1607256, 22.3055041],
          [114.1609306, 22.305965],
          [114.1610641, 22.3062519],
          [114.1610848, 22.3062979],
          [114.161195, 22.3065394],
          [114.1612005, 22.3065514],
          [114.1612231, 22.3065965],
          [114.1612285, 22.3066092],
          [114.1612359, 22.3066237],
          [114.1612471, 22.3066523],
          [114.1612585, 22.3066795],
          [114.1612668, 22.3067],
          [114.1612762, 22.3067234],
          [114.1613346, 22.3068367],
          [114.1613575, 22.3068682],
          [114.161385, 22.3068963],
          [114.1614165, 22.3069206],
          [114.1614514, 22.3069406],
          [114.161489, 22.3069559],
          [114.1615285, 22.3069661],
          [114.1615691, 22.3069711],
          [114.1616102, 22.3069708],
          [114.1616507, 22.3069652],
          [114.1621381, 22.3068104],
          [114.1625892, 22.3067055],
          [114.1626561, 22.3066913],
          [114.163278, 22.3065622],
          [114.163476, 22.3064954],
          [114.1635053, 22.3064855],
          [114.1635402, 22.3064735],
          [114.1635567, 22.3064508],
          [114.1635664, 22.3064375],
          [114.1635642, 22.3063666],
          [114.163557, 22.3057433],
          [114.1635124, 22.304953],
          [114.1635114, 22.304896],
          [114.1635105, 22.3048407],
          [114.1634934, 22.3039666],
          [114.1634924, 22.3039142],
          [114.1634893, 22.3037524],
          [114.1634817, 22.3033555],
          [114.1634757, 22.3030458],
          [114.1634703, 22.3030189],
          [114.1634581, 22.3029935],
          [114.1634495, 22.3029829],
          [114.16344, 22.3029714],
          [114.1634195, 22.3029547],
          [114.1633899, 22.3029413],
          [114.1633605, 22.302935],
          [114.1628524, 22.302911],
          [114.1624035, 22.3028973],
          [114.1622682, 22.3028934],
          [114.162015, 22.3028862],
          [114.1617401, 22.3028804],
          [114.1615058, 22.3029125],
          [114.1615074, 22.3028755],
          [114.1610003, 22.3028649],
          [114.1605942, 22.3028555],
          [114.1605315, 22.3028555],
          [114.1604309, 22.3028555],
          [114.1603568, 22.3028526],
          [114.1602827, 22.3028542],
          [114.1602476, 22.3028572],
          [114.1602077, 22.3028606],
          [114.1601683, 22.3028664],
          [114.1601289, 22.3028723],
          [114.16005, 22.3028896],
          [114.1599985, 22.3029057],
          [114.15995, 22.3029282],
          [114.1599052, 22.3029566],
          [114.1598651, 22.3029905],
          [114.1598305, 22.3030292],
          [114.1598019, 22.303072],
          [114.1597776, 22.3031242],
          [114.1597624, 22.3031792],
          [114.1597566, 22.3032358],
          [114.1597604, 22.3032926],
          [114.1597737, 22.303348],
          [114.1598995, 22.3036356],
          [114.1599232, 22.3036899],
          [114.1599696, 22.3037959],
          [114.159987, 22.3038357],
          [114.1599929, 22.3038534],
          [114.160008, 22.3038916],
          [114.1600125, 22.3039033],
          [114.160048, 22.303984],
          [114.1600523, 22.3039933],
          [114.1600633, 22.3040175],
          [114.1600681, 22.3040279],
          [114.1601896, 22.304299],
          [114.1602546, 22.3044439],
          [114.1602692, 22.3044768],
          [114.1603243, 22.3046021],
          [114.1603311, 22.3046175],
          [114.1605363, 22.3050788],
          [114.1605633, 22.3051394],
        ],
      ],
    },
    model: {
      video: 'https://assets.deepworldmodel.ai/preview_video/elements480.mov',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/elements_preview.png',
      name: {
        en: "Elements",
        zh: "圓方"
      }
    }
  },
  {
    code: "austin",
    name: "venue_austin_station",
    center: {
      lat: 22.30454035,
      lng: 114.1664803,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1664613, 22.3042371],
          [114.1667097, 22.3043544],
          [114.1667235, 22.304328],
          [114.1670707, 22.3036636],
          [114.1670778, 22.3036501],
          [114.167313, 22.3032],
          [114.1673372, 22.3031536],
          [114.1671945, 22.3031503],
          [114.166721, 22.3031393],
          [114.1666996, 22.3034827],
          [114.1666749, 22.3038401],
          [114.1666735, 22.3038601],
          [114.1664613, 22.3042371],
        ],
        [
          [114.1662124, 22.3047171],
          [114.1660464, 22.3050281],
          [114.1658333, 22.3054273],
          [114.1658083, 22.3054742],
          [114.1656234, 22.3058205],
          [114.1657671, 22.3058897],
          [114.1658792, 22.3059414],
          [114.1660171, 22.3056807],
          [114.1662284, 22.3052814],
          [114.1662934, 22.305313],
          [114.1663429, 22.3052203],
          [114.1663489, 22.3052092],
          [114.1663956, 22.3051217],
          [114.1663298, 22.3050862],
          [114.1664636, 22.3048247],
          [114.1662124, 22.3047171],
        ],
      ],
    },
    model: {
      name: {
        en: "Austin Station",
        zh: "柯士甸站"
      }
    }
  },
  {
    code: "xiqu",
    name: "venue_xiqu_centre",
    center: {
      lat: 22.30215795,
      lng: 114.16721385,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1667633, 22.3023546],
          [114.1667653, 22.3023723],
          [114.1667706, 22.3023894],
          [114.1667785, 22.302405],
          [114.1667886, 22.3024197],
          [114.1668, 22.3024321],
          [114.1668168, 22.3024451],
          [114.166833, 22.3024545],
          [114.1668509, 22.3024615],
          [114.1668692, 22.3024658],
          [114.1668905, 22.3024678],
          [114.1671004, 22.3024802],
          [114.1674512, 22.3025009],
          [114.1675328, 22.3025057],
          [114.1675502, 22.3025055],
          [114.1675644, 22.3025036],
          [114.1675804, 22.3024989],
          [114.1675948, 22.3024927],
          [114.1676104, 22.3024842],
          [114.1676233, 22.3024745],
          [114.1676348, 22.3024626],
          [114.1676471, 22.3024464],
          [114.1676555, 22.3024307],
          [114.1676608, 22.3024153],
          [114.1676643, 22.302396],
          [114.1676644, 22.3023786],
          [114.1676613, 22.302359],
          [114.1675388, 22.3019595],
          [114.1675301, 22.3019384],
          [114.1675192, 22.3019199],
          [114.1675073, 22.3019043],
          [114.1674914, 22.3018881],
          [114.1674705, 22.3018719],
          [114.1674488, 22.3018594],
          [114.1674257, 22.3018494],
          [114.1674083, 22.3018449],
          [114.1673886, 22.3018423],
          [114.1669388, 22.3018102],
          [114.166919, 22.3018103],
          [114.1668989, 22.3018128],
          [114.1668799, 22.3018181],
          [114.16686, 22.3018269],
          [114.1668394, 22.3018412],
          [114.1668245, 22.3018562],
          [114.1668133, 22.3018727],
          [114.1668052, 22.3018905],
          [114.1667995, 22.3019159],
          [114.1667633, 22.3023546],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/xiqu/xiqu_model.glb',
      center: {
        lat: 22.30215795,
        lng: 114.16721385,
        altitude: 0,
      },
      video: 'https://assets.deepworldmodel.ai/preview_video/xiqu480.mov',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/xiqu_preview.png',
      name: {
        en: "Xiqu Centre",
        zh: "戲曲中心"
      }
    }
  },
  {
    code: "westkowloonstation",
    name: "venue_west_kowloon_station",
    center: {
      lat: 22.3043,
      lng: 114.165,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1648886, 22.3031018],
          [114.1649098, 22.3030861],
          [114.1649304, 22.3030707],
          [114.1649838, 22.3030311],
          [114.1650924, 22.3031676],
          [114.1651349, 22.3031419],
          [114.165193, 22.3031067],
          [114.1653177, 22.3032818],
          [114.1653192, 22.3032655],
          [114.1653568, 22.3032643],
          [114.1653581, 22.303242],
          [114.1653943, 22.303242],
          [114.1653956, 22.3032246],
          [114.1654453, 22.3032209],
          [114.1654681, 22.3031973],
          [114.165527, 22.3032147],
          [114.1655754, 22.3031998],
          [114.1656986, 22.3032507],
          [114.165798, 22.3032593],
          [114.1658394, 22.3032867],
          [114.1658784, 22.3032556],
          [114.1659199, 22.3032904],
          [114.1659558, 22.303287],
          [114.1659938, 22.3032817],
          [114.1659991, 22.303299],
          [114.1660487, 22.3032867],
          [114.16605, 22.3033252],
          [114.1661557, 22.3033344],
          [114.1661289, 22.3035551],
          [114.1660935, 22.3038193],
          [114.1660664, 22.3039758],
          [114.1660246, 22.3041825],
          [114.1659776, 22.3043402],
          [114.1659012, 22.3045572],
          [114.1658246, 22.3047843],
          [114.1657484, 22.3047631],
          [114.1656867, 22.3049443],
          [114.1654776, 22.3053296],
          [114.1654232, 22.3054364],
          [114.1653239, 22.3055881],
          [114.165138, 22.3058365],
          [114.1649288, 22.3060896],
          [114.1648662, 22.3061648],
          [114.1648015, 22.3062272],
          [114.1647211, 22.3062496],
          [114.1643791, 22.3063215],
          [114.1643092, 22.3063178],
          [114.1642154, 22.306298],
          [114.1641644, 22.3062336],
          [114.1641482, 22.3061416],
          [114.1641402, 22.3060325],
          [114.1641524, 22.3055721],
          [114.1641484, 22.3054505],
          [114.1641471, 22.3052967],
          [114.1641444, 22.305247],
          [114.1641444, 22.3051503],
          [114.1641424, 22.3050138],
          [114.1641407, 22.3048283],
          [114.1641363, 22.30435],
          [114.1641353, 22.3042842],
          [114.1641347, 22.304244],
          [114.1641341, 22.3042048],
          [114.1641278, 22.3038029],
          [114.1641255, 22.3036515],
          [114.1641488, 22.3035532],
          [114.1641749, 22.3034434],
          [114.1641939, 22.3033636],
          [114.1642821, 22.3033697],
          [114.1643655, 22.3033748],
          [114.1643361, 22.3032978],
          [114.1644113, 22.3033077],
          [114.1643951, 22.3032358],
          [114.1644423, 22.3032266],
          [114.1644648, 22.3032222],
          [114.1644903, 22.3033215],
          [114.1645347, 22.3034194],
          [114.1645828, 22.3035125],
          [114.1646554, 22.3036117],
          [114.1646892, 22.3036453],
          [114.1647195, 22.3036812],
          [114.1647841, 22.3037408],
          [114.1648713, 22.3038102],
          [114.1649717, 22.3038835],
          [114.1650014, 22.3038822],
          [114.1650376, 22.303871],
          [114.1650698, 22.3038524],
          [114.1651154, 22.3038723],
          [114.1651556, 22.3038983],
          [114.1651836, 22.3039282],
          [114.1652361, 22.3038698],
          [114.1652562, 22.3038226],
          [114.1652749, 22.3037532],
          [114.165279, 22.3036862],
          [114.1652158, 22.3035758],
          [114.1651595, 22.3034815],
          [114.1650495, 22.3033152],
          [114.1648886, 22.3031018],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/west_kowloon_station/west_kowloon_station_20260226_1045.glb',
      center: {
        lat: 22.305189004120226,
        lng: 114.16465378897448,
        altitude: 0,
      },
      video: 'https://assets.deepworldmodel.ai/preview_video/westkowloon480.mov',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/westkowloon_preview.png',
      name: {
        en: "West Kowloon Station",
        zh: "西九龍站"
      }
    }
  },
  {
    code: "palacemuseum",
    name: "venue_palace_museum",
    center: {
      lat: 22.3016322,
      lng: 114.15550895000001,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.15649, 22.3020031],
          [114.1564666, 22.3019286],
          [114.1563025, 22.3017258],
          [114.1562639, 22.3016785],
          [114.1562165, 22.3016196],
          [114.1561818, 22.3015693],
          [114.1561528, 22.301516],
          [114.1561243, 22.3014453],
          [114.1561056, 22.3013718],
          [114.1560969, 22.3012968],
          [114.1560984, 22.3012213],
          [114.155977, 22.3011876],
          [114.1559152, 22.3011874],
          [114.1558939, 22.3011873],
          [114.1558576, 22.3011873],
          [114.1557076, 22.3011817],
          [114.1555696, 22.301171],
          [114.1555089, 22.301164],
          [114.1554322, 22.3011551],
          [114.1552956, 22.3011342],
          [114.15516, 22.3011081],
          [114.1550257, 22.301077],
          [114.1548819, 22.3010513],
          [114.1547231, 22.3010931],
          [114.1546698, 22.301115],
          [114.1546173, 22.3011448],
          [114.1545693, 22.3011819],
          [114.1545279, 22.3012243],
          [114.1545285, 22.3013029],
          [114.1545538, 22.3013028],
          [114.1545597, 22.3020067],
          [114.1545784, 22.3020065],
          [114.1545925, 22.3020064],
          [114.1546073, 22.3020063],
          [114.1546994, 22.3020057],
          [114.1547144, 22.3020056],
          [114.1548572, 22.3020047],
          [114.1548574, 22.3020335],
          [114.155026, 22.3020324],
          [114.1550411, 22.3020323],
          [114.1557951, 22.3020272],
          [114.1557956, 22.3020702],
          [114.1557962, 22.302131],
          [114.1557968, 22.3021831],
          [114.1558299, 22.3022131],
          [114.1559916, 22.3022116],
          [114.1560571, 22.302211],
          [114.1561564, 22.3022101],
          [114.1563117, 22.302209],
          [114.1563583, 22.3022067],
          [114.1563988, 22.3021964],
          [114.1563997, 22.3021461],
          [114.1564023, 22.3020018],
          [114.1564217, 22.3020021],
          [114.1564411, 22.3020024],
          [114.15649, 22.3020031],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/palace_museum/palace_museum_20260223_1300.glb',
      center: {
        lat: 22.301599,
        lng: 114.154907,
        altitude: 0,
      },
      name: {
        en: "Palace Museum",
        zh: "故宮博物館"
      }
    }
  },
];

export const findVenueCenter = (venueCode: string) => {
  const venue = venueData.find((eachVenue, index) => {
    return venueCode == eachVenue.code
  })
  if (venue) {
    return venue.center
  }
  return null;
}

export const getVenueModels = () => {
  const modelList: any[] = [];

  venueData.map(venue => {
    if (venue.model && venue.model.source) {
      modelList.push(venue)
    }
  })
  return modelList;
}

export const getSupportedVenueData = () => {
  const venueList: any[] = [];
  venueData.map((eachVenue, index) => {
    const featureList: {
      type: string;
      properties: {
        code: string;
        name: string;
        center: { lat: number; lng: number };
        modelReady: boolean;
        modelPreviewVideo: string;
        modelPreviewThumbnail: string;
        modelName: { en: string, zh: string };
      };
      geometry: { type: string; coordinates: number[][] };
    }[] = [];
    eachVenue.geofence.coordinates.map((coords: any) => {
      return featureList.push({
        type: "Feature",
        properties: {
          code: eachVenue.code,
          name: eachVenue.name,
          center: eachVenue.center,
          modelReady: venueWith3DModel.includes(eachVenue.name) ? true : false,
          modelPreviewVideo: eachVenue.model?.video ?? '',
          modelPreviewThumbnail: eachVenue.model?.thumbnail ?? '',
          modelName: eachVenue.model?.name
        },
        geometry: {
          type: "Polygon",
          coordinates: [coords],
        },
      });
    });
    const eachPolygon = {
      outterPolygon: eachVenue.geofence.coordinates[0] ?? [],
      center: eachVenue.center,
      type: "FeatureCollection",
      features: featureList,
      // [
      //   {
      //     type: "Feature",
      //     properties: {
      //       name: eachVenue.name
      //     },
      //     geometry: {
      //       type: "Polygon",
      //       coordinates: eachVenue.geofence.coordinates
      //     }
      //   }
      // ]
    };
    venueList.push(eachPolygon);
  });
  return venueList;
};
